import { IHttpClient } from "../../../lib/http";
import { useMemo } from "react";
import { CancellationPolicyDTO, dtoToEntity } from "./cancellationPolicy.dto";

export interface GetCancellationPoliciesRequest {
  propertyTicker: string;
}

async function getCancellationPolicies({
  propertyTicker,
  httpClient,
}: GetCancellationPoliciesRequest & {
  httpClient: IHttpClient;
}) {
  const cancellationPoliciesDTO: CancellationPolicyDTO[] = await httpClient.get<
    CancellationPolicyDTO[]
  >(`/api/backoffice/${propertyTicker}/cancellationpolicies`);
  return dtoToEntity(cancellationPoliciesDTO);
}

export const useCancellationPoliciesApi = (httpClient: IHttpClient) => {
  return useMemo(
    () => ({
      getCancellationPolicies: (propertyTicker: string) =>
        getCancellationPolicies({ propertyTicker, httpClient }),
    }),
    [httpClient]
  );
};
